import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from '../../makeup/makeup_type/MakeupType.module.sass';
import Button from '../../../../ui_kit/button/Button';
import BackButton from '../../back_button/BackButton';
import BODY_PRODUCT_TYPES from '../../../constants/body_product_types';
import TypeBlock from '../../makeup/makeup_type/type_block/TypeBlock';
import BODY_CATEGORIES from '../../../constants/body_categories';

function BodyType(props) {
  const {
    increaseStep, decreaseStep, quiz, step,
  } = props;

  const area = quiz.productType.split(' - ')[0];

  const detailedProductType = quiz.productType.split(' - ').slice(1).join(' - ');

  const types = BODY_PRODUCT_TYPES[area];

  const [customType, setCustomType] = useState(
    !types.includes(detailedProductType) ? detailedProductType : '',
  );

  const [type, setType] = useState(detailedProductType);

  const productType = `${area} - ${type}`;

  const onNextClick = () => {
    increaseStep({ ...quiz, productType });
  };

  const onCustomTypeChange = (updatedType) => {
    setCustomType(updatedType);
    setType(updatedType);
  };

  const { color } = quiz;

  const title = () => {
    switch (area) {
      case BODY_CATEGORIES.FULL_BODY:
        return 'Which type of body product do you want to upgrade?';
      case BODY_CATEGORIES.HANDS:
        return 'Which hands/feet selection needs more perfection?';
      case BODY_CATEGORIES.FACE:
        return 'Which product for the face do you want to elevate?';
      case BODY_CATEGORIES.LEGS:
        return 'Which leg/stomach benefit is your innovation about?';
      case BODY_CATEGORIES.UNDERARMS:
        return "So it's for the armpit, but what's the benefit?";
      default:
        return null;
    }
  };

  return (
    <>
      <BackButton decreaseStep={() => { decreaseStep({ ...quiz, productType }); }} />
      <div className={styles['makeup-type']}>
        <div className={styles.content}>
          {step}
          <h1 className={styles.title}>
            {title()}
          </h1>
          <div className={styles.description}>
            Select the best option or type other.
          </div>
          <div className={styles.types}>
            {types.map((typeText) => (
              <TypeBlock
                onClick={() => { setType(typeText); }}
                key={typeText}
                text={typeText}
                isActive={type === typeText}
                color={color}
              />
            ))}
            <TypeBlock
              onChange={onCustomTypeChange}
              onClick={() => { setType(customType); }}
              text={customType}
              isActive={type ? type === customType : false}
              color={color}
              editable
            />
          </div>
          <Button
            className={`${styles.button} custom-transparent-button`}
            onClickHandler={onNextClick}
            disabled={!type}
            text="NEXT"
            color="transparent-blue"
            size="small"
          />
        </div>
      </div>
    </>
  );
}

BodyType.propTypes = {
  increaseStep: PropTypes.func.isRequired,
  decreaseStep: PropTypes.func.isRequired,
  quiz: PropTypes.shape({
    productType: PropTypes.string,
    color: PropTypes.string,
  }).isRequired,
  step: PropTypes.node.isRequired,
};

export default BodyType;
